import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * Method to make sure that we don't stay logged-in too long on websites.
 * This is called in each of the app screens (pantries, visits etc) that
 * require a logged-in user. If its been too long ago that the user was
 * active (indicated by lastUpdated) then we log out. The various screens
 * will redirect to Language selection page.
 */
async function getToken(): Promise<string | null> {
  if (Platform.OS === 'web') {
    const lastUpdated: string | null = await AsyncStorage.getItem('lastUpdated');
    const now: number = new Date().getTime();
    const last: number = lastUpdated ? parseInt(lastUpdated, 10) : now;
    const sessionSeconds: number = 24 * 3600;
    if (now - last > 1000 * sessionSeconds) {
      await clearLocalToken();
      return null;
    }
    await AsyncStorage.setItem('lastUpdated', `${now}`);
  }

  const token: string | null = await AsyncStorage.getItem('token');
  return token;
}

/**
 * Clears the local authentication tokens from AsyncStorage.
 * This function removes the 'token', 'sessionId', and 'expiresAt' items.
 * It's typically used during logout or when resetting the user's session.
 * @function
 * @returns {Promise<void>}
 */
const clearLocalToken = async (): Promise<void> => {
  await Promise.all([
    AsyncStorage.removeItem('token'),
    AsyncStorage.removeItem('sessionId'),
    AsyncStorage.removeItem('expiresAt'),
  ]);
};

export { getToken, clearLocalToken };
